import {
  DropDownDTO,
  QuestionChoiceDTO,
  StandardQuestionUploadDTO,
} from "../../../common/types/common.dto.types";
import {
  BulkQuestionUploadPageType,
  EnumBulkQuestionUploadPageMode,
  PageNavigationType,
} from "./BulkUploadQuestionsPage.types";
import { createSlice } from "@reduxjs/toolkit";

/* ==============================|| VIEWS - PAGES - BULK UPLOAD QUESTIONS PAGE - REDUCER ||==============================  */

// set initial state values for BulkQuestionUploadPageType
const initialState = {
  StandardId: 0,
  UploadedFileName: "",
  StandardQuestionReviewList: [] as Array<StandardQuestionUploadDTO>,
  PageNavigation: { EnablePageNavigation: false, NavigationPage: "" },
  BulkQuestionUploadPageMode: EnumBulkQuestionUploadPageMode.UploadQuestionMode,
  ShowCategoryChoicesValidationMsg: false,
} as BulkQuestionUploadPageType;

export const bulkQuestionUploadSlice = createSlice({
  name: "bulkQuestionUpload",
  initialState: initialState,
  reducers: {
    setBulkQuestionUploadInitialData: (
      state: BulkQuestionUploadPageType,
      action: { payload: BulkQuestionUploadPageType; type: string }
    ) => {
      return {
        ...state,
        StandardId: action.payload.StandardId,
        UploadedFileName: action.payload.UploadedFileName,
        StandardQuestionReviewList: action.payload.StandardQuestionReviewList,
        BulkQuestionTypeList: action.payload.BulkQuestionTypeList,
        BulkQuestionCategoryDropdownList:
          action.payload.BulkQuestionCategoryDropdownList,
        BulkQuestionCategoryChoiceList:
          action.payload.BulkQuestionCategoryChoiceList,
        ShowCategoryChoicesValidationMsg:
          action.payload.ShowCategoryChoicesValidationMsg,
      };
    },
    setUploadedFileName: (
      state: BulkQuestionUploadPageType,
      action: { payload: string; type: string }
    ) => {
      return {
        ...state,
        UploadedFileName: action.payload ?? "",
      };
    },
    setStandardQuestionReviewList: (
      state: BulkQuestionUploadPageType,
      action: { payload: Array<StandardQuestionUploadDTO>; type: string }
    ) => {
      const standardQuestionList = [
        ...action.payload?.map((question, index) => {
          const displayId = question.SequenceNumber;
          const sequenceNumber = index + 1;

          return {
            ...question,
            RowId: `${sequenceNumber}`,
            SequenceNumber: sequenceNumber,
            DisplayId: displayId,
          };
        }),
      ];

      return {
        ...state,
        StandardQuestionReviewList: standardQuestionList,
      };
    },
    setBulkQuestionUploadPageMode: (
      state: BulkQuestionUploadPageType,
      action: { payload: EnumBulkQuestionUploadPageMode; type: string }
    ) => {
      return {
        ...state,
        BulkQuestionUploadPageMode: action.payload,
      };
    },
    setBulkQuestionTypeList: (
      state: BulkQuestionUploadPageType,
      action: { payload: Array<DropDownDTO>; type: string }
    ) => {
      return {
        ...state,
        BulkQuestionTypeList: action.payload,
      };
    },
    setBulkUploadQuestionDropdownCategories: (
      state: BulkQuestionUploadPageType,
      action: { payload: Array<DropDownDTO>; type: string }
    ) => {
      return {
        ...state,
        BulkQuestionCategoryDropdownList: action.payload,
      };
    },
    setBulkUploadQuestionCategoryChoices: (
      state: BulkQuestionUploadPageType,
      action: { payload: Array<QuestionChoiceDTO>; type: string }
    ) => {
      return {
        ...state,
        BulkQuestionCategoryChoiceList: action.payload,
      };
    },
    setPageNavigation: (
      state: BulkQuestionUploadPageType,
      action: { payload: PageNavigationType; type: string }
    ) => {
      return {
        ...state,
        PageNavigation: {
          EnablePageNavigation: action.payload.EnablePageNavigation,
          NavigationPage: action.payload.NavigationPage,
        },
      };
    },
    showCategoryChoicesValidationMsg: (
      state: BulkQuestionUploadPageType,
      action: { payload: boolean; type: string }
    ) => {
      return {
        ...state,
        ShowCategoryChoicesValidationMsg: action.payload,
      };
    },
    resetBulkQuestionUploadState: (state: BulkQuestionUploadPageType) => {
      return {
        ...state,
        UploadedFileName: "",
        BulkQuestionUploadPageMode:
          EnumBulkQuestionUploadPageMode.UploadQuestionMode,
        StandardQuestionReviewList: [],
        BulkQuestionCategoryDropdownList: [],
        BulkQuestionCategoryChoiceList: [],
        PageNavigation: {
          EnablePageNavigation: false,
          NavigationPage: "",
        },
        ShowCategoryChoicesValidationMsg: false,
      };
    },
  },
});

export const {
  setBulkQuestionUploadInitialData,
  setStandardQuestionReviewList,
  resetBulkQuestionUploadState,
  setBulkQuestionTypeList,
  setBulkUploadQuestionDropdownCategories,
  setBulkUploadQuestionCategoryChoices,
  setPageNavigation,
  setBulkQuestionUploadPageMode,
  setUploadedFileName,
  showCategoryChoicesValidationMsg,
} = bulkQuestionUploadSlice.actions;

export const bulkQuestionUploadReducer = bulkQuestionUploadSlice.reducer;
